// Fetches JSON from the site's own API; rejects with a readable message on any HTTP error.
export async function getJSON(path, { signal } = {}) {
  const res = await fetch(path, { signal })
  if (res.status === 401) window.dispatchEvent(new Event('wl-signed-out'))
  if (!res.ok) {
    let message = `HTTP ${res.status}`
    try {
      const body = await res.json()
      if (body.error) message = body.error
    } catch {
      // not JSON; keep the status
    }
    throw new Error(message)
  }
  return res.json()
}

// Sends a JSON PATCH to the site's own API and returns the JSON reply; errors as getJSON.
export function patchJSON(path, body) {
  return sendJSON('PATCH', path, body)
}

// Sends a JSON PUT to the site's own API and returns the JSON reply; errors as getJSON.
export function putJSON(path, body) {
  return sendJSON('PUT', path, body)
}

// Sends a JSON POST to the site's own API and returns the JSON reply; errors as getJSON.
export function postJSON(path, body) {
  return sendJSON('POST', path, body)
}

// Sends a DELETE to the site's own API and returns the JSON reply; errors as getJSON.
export function deleteJSON(path) {
  return sendJSON('DELETE', path)
}

async function sendJSON(method, path, body) {
  const res = await fetch(path, {
    method,
    headers: body === undefined ? {} : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  if (res.status === 401) window.dispatchEvent(new Event('wl-signed-out'))
  if (!res.ok) {
    let message = `HTTP ${res.status}`
    try {
      const reply = await res.json()
      if (reply.error) message = reply.error
    } catch {
      // not JSON; keep the status
    }
    throw new Error(message)
  }
  return res.json()
}
